import React from 'react';
import { useTheme } from '../../../contexts/ThemeContext';
import { cn } from '../../../lib/utils';
import { Button, ReportView } from '../../../components/ui';

export type ReportShellProps = {
  periodId: number;
  title: string;
  subtitle?: string;
  loading?: boolean;
  empty?: boolean;
  emptyMessage?: string;
  /** Secondary download (Excel / CSV). */
  downloadLabel?: string;
  onDownload?: () => void | Promise<void>;
  downloading?: boolean;
  children: React.ReactNode;
};

/** On-screen chrome + Print / Save as PDF for MGA HTML reports (via shared ReportView). */
export const ReportShell: React.FC<ReportShellProps> = ({
  periodId,
  title,
  subtitle,
  loading,
  empty,
  emptyMessage = 'Nothing to show for this report.',
  downloadLabel,
  onDownload,
  downloading,
  children,
}) => {
  const { colors } = useTheme();

  if (loading) {
    return (
      <div className={cn('flex min-h-[40vh] items-center justify-center text-sm', colors.textMuted)}>
        Loading…
      </div>
    );
  }

  return (
    <ReportView
      backTo={`/mga/${periodId}`}
      backLabel="← Back to period"
      title={title}
      subtitle={subtitle}
      printPageSize="A4 portrait"
      printMargin="0"
      empty={Boolean(empty)}
      emptyMessage={emptyMessage}
      actions={
        downloadLabel && onDownload ? (
          <Button
            type="button"
            variant="outline"
            size="sm"
            disabled={downloading || empty}
            onClick={() => void onDownload()}
          >
            {downloading ? 'Downloading…' : downloadLabel}
          </Button>
        ) : null
      }
    >
      {children}
    </ReportView>
  );
};

export default ReportShell;
